export enum ApplicationAction {
	Create = 'create',
	Update = 'update',
}

export enum QualityType {
	First = '1-й сорт',
	Second = '2-й сорт',
}

export enum EnFieldName {
	FishKind = 'fishKind',
	CutType = 'cutType',
	Size = 'size',
	OnePieceWeightNet = 'onePieceWeightNet',
	BoxType = 'boxType',
	BoxWeight = 'boxWeight',
	Manufacturer = 'manufacturer',
	QualityType = 'qualityType',
	BatchNumber = 'batchNumber',
	Amount = 'amount',
}

export const RuFieldName = {
	[EnFieldName.FishKind]: 'ВБР',
	[EnFieldName.CutType]: 'Вид разделки',
	[EnFieldName.Size]: 'Размер рыбы',
	[EnFieldName.OnePieceWeightNet]: 'Масса одного места, нетто, кг',
	[EnFieldName.BoxType]: 'Тара',
	[EnFieldName.BoxWeight]: 'Масса одной тары, кг',
	[EnFieldName.Manufacturer]: 'Изготовитель товара',
	[EnFieldName.QualityType]: 'Сорт',
	[EnFieldName.BatchNumber]: 'Номер партии',
	[EnFieldName.Amount]: 'Количество мест, шт',
} as const;

export const RuFields = [
	RuFieldName[EnFieldName.FishKind],
	RuFieldName[EnFieldName.CutType],
	RuFieldName[EnFieldName.Size],
	RuFieldName[EnFieldName.OnePieceWeightNet],
	RuFieldName[EnFieldName.BoxType],
	RuFieldName[EnFieldName.BoxWeight],
	RuFieldName[EnFieldName.Manufacturer],
	RuFieldName[EnFieldName.QualityType],
	RuFieldName[EnFieldName.BatchNumber],
	RuFieldName[EnFieldName.Amount],
];

export const SortsValues = {
	[QualityType.First]: 1,
	[QualityType.Second]: 2,
};

export enum ApplicationStatus {
	New = 0,
	Confirmed = 1,
	Accepted = 2,
	Completed = 3,
	Rejected = 4,
	NotSent = 5,
	Revision = 6,
	Fixed = 7,
	Renegotiation = 8,
	OnEditing = 9,
	ToBeSigned = 10,
	Read = 11,
	Cancelled = 12,
}

export enum ApplicationActions {
	New = 'new',
	Confirmed = 'confirmed',
	Accepted = 'accepted',
	Completed = 'completed',
	ManuallyComplete = 'manually_completed',
	Rejected = 'rejected',
	NotSent = 'not_sent',
	Revision = 'revision',
	Fixed = 'fixed',
	Renegotiation = 'renegotiation',
	OnEditing = 'on_editing',
	Signed = 'signed',
	Read = 'read',
	Cancelled = 'cancelled',
}

export enum ApplicationTypes {
	Storage = 0,
	Transfer = 1,
	Shipment = 2,
	AdditionalServices = 3,
	Agreement = 4,
	Purchase = 5,
	AddResource = 6,
}

export const EditableStatuses: number[] = [ApplicationStatus.NotSent, ApplicationStatus.Revision];

export const ApplicationTypesName = {
	[ApplicationTypes.Storage]: 'Хранение',
	[ApplicationTypes.Transfer]: 'Передача',
	[ApplicationTypes.Shipment]: 'Отгрузка',
	[ApplicationTypes.AdditionalServices]: 'Допуслуга',
	[ApplicationTypes.Agreement]: 'Договор',
	[ApplicationTypes.Purchase]: 'Покупка',
	[ApplicationTypes.AddResource]: 'Добавление',
};

export const ApplicationStatusName = {
	[ApplicationStatus.New]: 'Новая',
	[ApplicationStatus.Confirmed]: 'Подтверждена',
	[ApplicationStatus.Accepted]: 'Принята',
	[ApplicationStatus.Completed]: 'Выполнена',
	[ApplicationStatus.Rejected]: 'Отклонена',
	[ApplicationStatus.NotSent]: 'Не отправлена',
	[ApplicationStatus.Revision]: 'Отправлена на доработку',
	[ApplicationStatus.Fixed]: 'Исправлена',
	[ApplicationStatus.Renegotiation]: 'Пересогласование',
	[ApplicationStatus.OnEditing]: 'Редактируется',
	[ApplicationStatus.ToBeSigned]: 'На подписи получателем',
	[ApplicationStatus.Read]: 'Прочитана',
	[ApplicationStatus.Cancelled]: 'Отменена',
};

export const APPLICATIONS_PATHS = {
	[ApplicationTypes.AddResource]: '/add-products/',
	[ApplicationTypes.Storage]: '/storage-application/',
	[ApplicationTypes.Agreement]: '/agreement-application/',
	[ApplicationTypes.Transfer]: '/transfer-application/',
	[ApplicationTypes.Shipment]: '/shipment-application/',
	[ApplicationTypes.AdditionalServices]: '/service-application/',
	[ApplicationTypes.Purchase]: '/purchase-application/',
};
